import { State } from '@/store/index';
import { Module } from 'vuex';
import { ItemApi, ItemRead } from '@/api';
import axios from 'axios';
import helpers from '../services/helpers';

function getItemApi(): ItemApi {
  return new ItemApi(undefined, import.meta.env.VITE_PROXY_URL, axios);
}

const getDefaultState = () => ({
  items: {} as Record<'audiovisual' | 'food_beverage' | 'other', ItemRead[]>,
  loading: false,
});

export type itemState = ReturnType<typeof getDefaultState>;

export const Items: Module<itemState, State> = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setItems(state: itemState, response: Array<ItemRead>) {
      state.items = helpers.groupBy(response, 'category');
    },
    setLoading(state: itemState, isLoading: boolean) {
      state.loading = isLoading;
    },
  },

  actions: {
    async fetchItems({ commit }, locationId: number) {
      commit('setLoading', true);

      const ItemApi = getItemApi();
      const response = await ItemApi.itemsGetCollection({
        location: `/api/locations/${locationId}`,
        available: true,
      });

      commit('setItems', response.data['hydra:member']);
      commit('setLoading', false);
    },
  },
};
